import React from "react";

import styles from "./saveButton.module.scss";

interface Props {
  title?: string;
  formId?: string;
  onClick?: () => void;
  type?: string;
  wrapperClass?: string;
}

const SaveButton: React.FC<Props> = ({
  title,
  formId,
  onClick,
  type = "default",
  wrapperClass,
}) => {
  return (
    <div className={wrapperClass ? wrapperClass : styles["g-save__wrapper"]}>
      <button
        type="button"
        className={`${styles["g-save__button"]} ${styles[type]}`}
        form={formId}
        onClick={onClick}
      >
        {title ? title : "保存"}
      </button>
    </div>
  );
};

export default SaveButton;
